import { Dispatch } from 'redux';
import {
  DECREASE_LOADING,
  DECREASE_LOAD_BALANCE,
  DECREASE_UPLOAD_LOADING,
  INCREASE_LOADING,
  INCREASE_LOAD_BALANCE,
  INCREASE_UPLOAD_LOADING,
  DECREASE_DETAILS_LOADING,
  INCREASE_DETAILS_LOADING,
  INCREASE_EXTRACT_LOAD,
  DECREASE_EXTRACT_LOAD,
  INCREASE_CARD_LOAD,
  DECREASE_CARD_LOAD,
} from './actionTypes';

export type LoadingAction = { type: string; payload?: undefined };
export type LoadingDispatch = Dispatch<LoadingAction>;

export const increaseLoading = () => ({
  type: INCREASE_LOADING,
});

export const decreaseLoading = () => ({
  type: DECREASE_LOADING,
});

export const increaseUploadLoading = () => ({
  type: INCREASE_UPLOAD_LOADING,
});

export const decreaseUploadLoading = () => ({
  type: DECREASE_UPLOAD_LOADING,
});

export const increaseDetailsLoading = () => ({
  type: INCREASE_DETAILS_LOADING,
});

export const decreaseDetailsLoading = () => ({
  type: DECREASE_DETAILS_LOADING,
});

export const increaseBalanceLoading = () => ({
  type: INCREASE_LOAD_BALANCE,
});

export const decreaseBalanceLoading = () => ({
  type: DECREASE_LOAD_BALANCE,
});

export const increaseExtractLoading = () => ({
  type: INCREASE_EXTRACT_LOAD,
});

export const decreaseExtractLoading = () => ({
  type: DECREASE_EXTRACT_LOAD,
});

export const increaseCardLoading = () => ({
  type: INCREASE_CARD_LOAD,
});

export const decreaseCardLoading = () => ({
  type: DECREASE_CARD_LOAD,
});
